import * as React from "react";
const Svg11Mp = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 3v18h18V3H3zm5 2.5h3v6H9.5V7H8V5.5zm4.5 13H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5v6zm.5-13h3v6h-1.5V7H13V5.5zM18 17h-3v1.5h-1.5v-6H18V17z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 14h1.5v1.5H15z",
  fill: "currentColor"
}));
export default Svg11Mp;